import { render, staticRenderFns } from "./AreaItem.vue?vue&type=template&id=08499260&scoped=true&"
import script from "./AreaItem.vue?vue&type=script&lang=js&"
export * from "./AreaItem.vue?vue&type=script&lang=js&"
import style0 from "./AreaItem.vue?vue&type=style&index=0&id=08499260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08499260",
  null
  
)

export default component.exports